import { gql, useMutation } from '@apollo/client';
import { GqlError, formatErrors } from '../utils/errors';

const REVOKE_MEMBER_EVENT_TICKET_MUTATION = gql`
  mutation revokeMemberEventTicketMutation($id: Int!) {
    revokeMemberEventTicket(ticketId: $id) {
      id
    }
  }
`;

const useRevokeMemberEventTicket = (onCompleted) => {
  const [revokeMemberEventTicketMutation, { loading, data, error }] = useMutation(
    REVOKE_MEMBER_EVENT_TICKET_MUTATION,
    { onCompleted },
  );

  const revokeMemberEventTicket = async ({ id }) => {
    try {
      const response = await revokeMemberEventTicketMutation({
        variables: {
          id,
        },
      });
      return response.data.revokeMemberEventTicket;
    } catch (e) {
      const formattedErrors = formatErrors(e);
      throw new GqlError({
        name: 'Ticket Revoke Error',
        errors: formattedErrors,
      });
    }
  };

  return [
    revokeMemberEventTicket,
    {
      loading,
      data,
      error: error ? formatErrors(error) : null,
    },
  ];
};

export default useRevokeMemberEventTicket;
